import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import Meta from '@bizapp-lp/pjr/organisms/Meta';
import { Complete } from '@bizapp-lp/pjr/templates/Complete';

type CompleteState = {
  valid?: boolean;
};

const title =
  'Project Room 無料トライアルお申し込み完了 | 社内外とのプロジェクトを複数同時に進める現場のコラボレーションを支援・促進します';
const description =
  'Project Roomは、プロジェクトのための、簡単・安全に利用できるコミュニケーションツール。社外関係者も含めたプロジェクトメンバー全体のコミュニケーションを活性化し、エンゲージメントを向上します。プロジェクトで取り扱うファイルや予定の共有も一か所に集約でき、情報共有やノウハウ蓄積、共同作業をサポートします。';

const Page: React.FC = () => {
  const { state } = useLocation() as { state: CompleteState };

  return state?.valid ? (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1={'無料トライアルのお申し込み'}
        heading2={'お申し込みが完了しました'}
        description={
          <>
            <span>お申し込みいただき、ありがとうございました。</span>
            <span>確認のためお客様へ自動返信メールをお送りしております。</span>
            <span>準備が整い次第弊社担当よりご連絡いたしますので、</span>
            <span>今しばらくお待ちください。</span>
          </>
        }
      />
    </>
  ) : (
    <Navigate to="/pjr/invalid" replace />
  );
};

const CompleteTrialApplication = React.memo(Page);
export default CompleteTrialApplication;
